import CurrencyToSymbol from './CurrencyToSymbol';

export default CurrencyToSymbol;
